import React, { useEffect, useState } from "react";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket, api } from "../api";
import { useNavigate } from "react-router-dom";
import Footer from "../components/navbar/Footer";
import {
  FaTelegramPlane,
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaTiktok,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { parseJWT } from "../utils/jwtUtils";

export default function ProfilePage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);
  const navigate = useNavigate();
  const [balance, setBalance] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);
  // console.log("user detail : ", userInfo);
  const handleEditProfile = () => {
    navigate("/profile-update");
  };
  const handleLogout = (e) => {
    e.preventDefault(); // prevent default link navigation
    localStorage.removeItem("userInfo"); // remove user info if stored
    window.location.href = "/login"; // redirect to login page
  };

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        if (!userInfo?.referralCode) {
          setMessage("No referral code found for this user.");
          setLoading(false);
          return;
        }

        // ✅ Fetch referrals using shared API instance
        const { data } = await api.get(`/referrals/${userInfo.referralCode}`);
        // console.log("referral info : ", data);
        if (data.success) {
          setTotalIncome(data.totalIncome || 0);
          setMessage("");
        } else {
          setMessage(data.message || "Unable to load referral data.");
        }
      } catch (err) {
        console.error("⚠️ Failed to fetch referral history:", err);
        setMessage("Failed to load referral history. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  }, []);

  const handleShareReferral = (refCode) => {
    if (!refCode) {
      alert("Referral code not found!");
      return;
    }

    const signupUrl = `https://zemedbingo.com/signup?ref=${refCode}`;
    const message = `በእርሶ ሪፈራል ኮዶ አንድ ሰው ሲመዘገብ 2 ብር ተከፋይ ይሆናሉ : ${refCode}\nአሁኑኑ ይመዝገቡ : ${signupUrl}`;

    // Open each link directly
    const shareLinks = {
      Telegram: `https://t.me/share/url?url=${encodeURIComponent(
        signupUrl,
      )}&text=${encodeURIComponent(message)}`,
      WhatsApp: `https://api.whatsapp.com/send?text=${encodeURIComponent(
        message,
      )}`,
      Facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        signupUrl,
      )}`,
      TikTok: `https://www.tiktok.com/share?url=${encodeURIComponent(
        signupUrl,
      )}`,
      Instagram: `https://www.instagram.com/`, // can't prefill text
    };

    return shareLinks;
  };
  const { t: translate } = useTranslation(["ProfilePage"]);
  return (
    <>
      {/* Navbar */}
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900">
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-primary text-white flex flex-col items-center p-4 pt-36 md:pt-20">
        {/* Profile Header */}
        <div className="w-full max-w-3xl bg-[#134454] p-6 rounded-2xl shadow-xl flex flex-col lg:flex-row items-center gap-6">
          {/* Avatar */}
          <div className="w-32 h-32 rounded-full bg-gray-800 flex items-center justify-center text-4xl font-bold">
            👤
          </div>

          {/* Basic Info */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-2xl font-semibold">{userInfo?.username}</h1>
            {/* <p className="text-gray-400 text-sm">Player ID: #BINGO2045</p> */}
            <p className="text-gray-400 text-sm mt-1 font-serif">
              {translate("Phone")} : {userInfo?.phone}
            </p>
            <p className="text-gray-400 text-sm font-serif">
              {translate("Referral_Code")} :{userInfo?.referralCode}
            </p>

            <div className="flex gap-4 mt-4 justify-center lg:justify-start">
              <button
                onClick={handleEditProfile}
                className="font-serif bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg text-sm font-semibold"
              >
                {translate("Edit_Profile")}
              </button>
              <button
                onClick={handleLogout}
                className="font-serif bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-sm font-semibold"
              >
                {translate("Logout")}
              </button>
            </div>
          </div>
        </div>

        {/* Wallet Section */}
        <div className="w-full max-w-3xl mt-8 bg-[#134454] rounded-2xl p-6 shadow-lg">
          <h2 className="text-xl font-semibold mb-4 border-b border-gray-500 pb-2 font-serif">
            💰 {translate("Wallet_Summary")}
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="bg-primary p-4 rounded-xl text-center">
              <p className="text-gray-400 text-sm font-serif">
                {translate("Main_Balance")}
              </p>
              <p className="text-2xl font-bold text-green-400 font-serif">
                {balance} {translate("ETB")}
              </p>
            </div>
            <div className="bg-primary p-4 rounded-xl text-center">
              <p className="text-gray-400 text-sm font-serif">
                {translate("Bonus_Balance")}
              </p>

              {loading ? (
                <p className="text-gray-300">Loading...</p>
              ) : message ? (
                <p className="text-red-400">{message}</p>
              ) : (
                <p className="text-2xl font-bold text-green-400 font-serif">
                  {totalIncome.toFixed(1)} {translate("ETB")}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Account Settings */}
        <div className="w-full max-w-3xl mt-8 bg-[#134454] rounded-2xl p-6 shadow-lg">
          <h2 className="text-xl font-semibold mb-4 border-b border-gray-500 pb-2 font-serif">
            ⚙️ {translate("Account_Settings")}
          </h2>

          <div className="space-y-3">
            <button
              onClick={handleEditProfile}
              className="w-full py-3 bg-primary hover:bg-cyan-800 rounded-lg text-left px-4 font-serif"
            >
              🔐 {translate("Change_Password")}
            </button>
            <button
              onClick={handleEditProfile}
              className="w-full py-3 bg-primary hover:bg-cyan-800 rounded-lg text-left px-4 font-serif"
            >
              📱 {translate("Update_Phone")}
            </button>
            <button
              onClick={handleEditProfile}
              className="w-full py-3 bg-primary hover:bg-cyan-800 rounded-lg text-left px-4 font-serif"
            >
              💳 {translate("Manage_Bank")}
            </button>
            <h2> {translate("share")}</h2>
            <div className="flex gap-3 mt-2">
              <button
                onClick={() =>
                  window.open(
                    handleShareReferral(userInfo?.referralCode).Telegram,
                    "_blank",
                  )
                }
                className="p-3 bg-blue-500 hover:bg-blue-600 rounded-full transition"
                title="Telegram"
              >
                <FaTelegramPlane size={24} />
              </button>
              <button
                onClick={() =>
                  window.open(
                    handleShareReferral(userInfo?.referralCode).WhatsApp,
                    "_blank",
                  )
                }
                className="p-3 bg-green-500 hover:bg-green-600 rounded-full transition"
                title="WhatsApp"
              >
                <FaWhatsapp size={24} />
              </button>
              <button
                onClick={() =>
                  window.open(
                    handleShareReferral(userInfo?.referralCode).Facebook,
                    "_blank",
                  )
                }
                className="p-3 bg-blue-800 hover:bg-blue-900 rounded-full transition"
                title="Facebook"
              >
                <FaFacebookF size={24} />
              </button>
              <button
                onClick={() =>
                  window.open(
                    handleShareReferral(userInfo?.referralCode).TikTok,
                    "_blank",
                  )
                }
                className="p-3 bg-black hover:bg-gray-800 rounded-full transition"
                title="TikTok"
              >
                <FaTiktok size={24} />
              </button>
              <button
                onClick={() =>
                  window.open(
                    handleShareReferral(userInfo?.referralCode).Instagram,
                    "_blank",
                  )
                }
                className="p-3 bg-pink-500 hover:bg-pink-600 rounded-full transition"
                title="Instagram"
              >
                <FaInstagram size={24} />
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
